import { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import styles from './M42HighlightRichtext.module.scss';
import { Slider } from 'ui/components/3-organisms/Slider';
import { SliderItemProps } from '../Slider/SliderItem';
import { Container, Heading, RichText } from 'ui/components';

export interface M42HighlightRichtextProps {
	className?: string;
	dictionary?: { [key: string]: string };
	header?: string;
	subheader?: string;
	text?: RichText['content'];
	sliderAriaControls?: string;
	highlightImages?: SliderItemProps[];
	anchor?: string;
}

export const M42HighlightRichtext: React.FC<M42HighlightRichtextProps> = ({
	className,
	dictionary,
	header,
	subheader,
	text,
	sliderAriaControls,
	highlightImages,
	anchor,
}) => {
	const sliderRef = useRef<HTMLDivElement>(null);

	return (
		<section className={classNames(styles.M42HighlightRichtext, className)} id={anchor}>
			<Container width="StandardWeb" className={styles.M42HighlightRichtext_wrapper}>
				<div className={styles.M42HighlightRichtext_textContentContainer}>
					{header && (
						<Heading headingLevel="h1" style="displaySm" className={styles.M42HighlightRichtext_heading}>
							{header}
						</Heading>
					)}
					{subheader && <p className={styles.M42HighlightRichtext_text}>{subheader}</p>}
					{text && <RichText content={text} variant="website" className={styles.M42HighlightRichtext_richText} />}
				</div>
				<Slider
					sliderRef={sliderRef}
					slides={highlightImages}
					autoHeight={true}
					showPagination={false}
					className={styles.M42HighlightRichtext_slider}
					slideStyleClass={styles.M42HighlightRichtext_slide}
					dictionary={dictionary}
					sliderAriaControls={sliderAriaControls}
					slideAspectRatio={0.7}
					navButtonsClassName={styles.M42HighlightRichtext_navButtons}
				></Slider>
			</Container>
		</section>
	);
};
